import getDefaultState from './defaultState';

export default getDefaultState();



// WEBPACK FOOTER //
// ./src/store/modules/ski/skistar/state.js